module.exports = __webpack_public_path__ + "static/media/logo.49159296.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 628
// module chunks = 0